import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

export const CtaBanner = ({ variant = "dark" }) => {
  const { t, lang } = useLang();
  const isDark = variant === "dark";
  return (
    <section className={`${isDark ? "bg-[#1A1A1A] text-[#F9F8F6]" : "bg-[#EFEBE6] text-[#1A1A1A]"} py-20 lg:py-28`}>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid lg:grid-cols-2 gap-10 items-end">
        <motion.h3
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter leading-[0.95]"
        >
          {lang === "de"
            ? "Bereit für einen Boden, der bleibt?"
            : "Ready for a floor that lasts?"}
        </motion.h3>
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="flex flex-col sm:flex-row gap-4 sm:items-center lg:justify-end"
        >
          <Link
            to="/contact"
            className="btn-primary"
            style={isDark ? { background: "#F9F8F6", color: "#1A1A1A" } : undefined}
            data-testid="cta-banner-primary"
          >
            {t("hero.cta_primary")}
            <ArrowRight size={16} />
          </Link>
          <Link
            to="/products"
            className="btn-ghost"
            style={isDark ? { borderColor: "#F9F8F6", color: "#F9F8F6" } : undefined}
            data-testid="cta-banner-secondary"
          >
            {t("products.explore")}
          </Link>
        </motion.div>
      </div>
    </section>
  );
};
